<template>
    <v-container grid-list-md fluid>
        <template v-if="isAuthorized">
            <v-row
                no-gutters
                class="mb-1"
                v-if="
                    showSepa ||
                    openPointMode ||
                    (availableDiagnostics && availableDiagnostics.length > 1)
                "
            >
                <v-col cols="2" v-if="showSepa && !openPointMode">
                    <v-btn-primary block @click="payDialog = true" :disabled="disabledSepa">{{
                        sepaTitle
                    }}</v-btn-primary>
                </v-col>
                <v-spacer />
                <v-col class="d-flex justify-end">
                    <v-select
                        v-model="diagnosticSorting"
                        :items="availableDiagnostics"
                        class="pr-2"
                        outlined
                        hide-details
                        v-if="availableDiagnostics && availableDiagnostics.length > 1"
                        density="compact"
                    />
                    <!-- <v-btn color="primary" icon elevation="0" @click="startTuto()">
                        <v-icon>$oss-help</v-icon>
                    </v-btn> -->
                </v-col>
                <v-col cols="2" class="pr-2" v-if="openPointMode">
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-primary :loading="exportLoading" v-bind="props" block
                                >Exporter</v-btn-primary
                            >
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="(item, index) in [
                                    { title: 'docx', icon: '$fa-file-word' },
                                    { title: 'xlsx', icon: '$fa-file-excel' },
                                    { title: 'pdf', icon: '$fa-file-pdf' },
                                ]"
                                :key="index"
                                class="px-8"
                                @click="exportToFormat(item.title)"
                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon color="secondary">
                                        {{ item.icon }}
                                    </v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row no-gutters v-if="loading">
                <v-col>
                    <v-progress-circular indeterminate color="primary" class="mr-3" />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-window v-model="wizardStep" v-if="!loading && openPoints != null">
                        <v-window-item :value="1">
                            <v-row class="pb-2" v-if="openPointMode">
                                <v-col v-if="openPoints.document">
                                    <v-row
                                        no-gutters
                                        class="pa-3 fill-height bg-primary-foreground rounded-xl"
                                        @click="showItems(openPoints.document.notAnalysed)"
                                    >
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center justify-center"
                                            style="border-right: 1px #ededed solid"
                                        >
                                            <v-icon
                                                :color="
                                                    openPoints.document.notAnalysed.count
                                                        ? 'red'
                                                        : 'green'
                                                "
                                                >{{
                                                    openPoints.document.notAnalysed.count
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"
                                                }}</v-icon
                                            >
                                        </v-col>
                                        <v-col cols="10" class="d-flex align-center pl-2">
                                            {{
                                                $t("openPoints.notAnalysedDocuments", {
                                                    count: openPoints.document.notAnalysed.count,
                                                })
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="auditCheckDocumentsWithAnomalyCount > 0">
                                    <AuditCheckCard
                                        :auditCheckItemsCount="auditCheckDocumentsWithAnomalyCount"
                                        @click="onAuditCheckCardClicked"
                                        class="cursor-pointer"
                                    >
                                    </AuditCheckCard>
                                    <AuditCheckDocumentDialog
                                        v-model="shouldAuditCheckDocumentWithAnomalyDialogBeVisible"
                                        :auditChecks="auditCheckDocumentsWithAnomaly"
                                        :companyId="companyId"
                                    />
                                </v-col>
                                <v-col
                                    v-if="
                                        openPoints.document && openPoints.document.pendingValidation
                                    "
                                >
                                    <v-row
                                        no-gutters
                                        class="pa-3 fill-height bg-primary-foreground rounded-xl"
                                        @click="showItems(openPoints.document.pendingValidation)"
                                    >
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center justify-center"
                                            style="border-right: 1px #ededed solid"
                                        >
                                            <v-icon
                                                :color="
                                                    openPoints.document.pendingValidation.count
                                                        ? 'red'
                                                        : 'green'
                                                "
                                                >{{
                                                    openPoints.document.pendingValidation.count
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"
                                                }}</v-icon
                                            >
                                        </v-col>
                                        <v-col cols="10" class="d-flex align-center pl-2">
                                            {{
                                                $t("openPoints.toValidateDocuments", {
                                                    count: openPoints.document.pendingValidation
                                                        .count,
                                                })
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="
                                        openPoints.reconciliation &&
                                        openPoints.reconciliation.pendingValidation
                                    "
                                >
                                    <v-row
                                        no-gutters
                                        class="pa-3 fill-height bg-primary-foreground rounded-xl"
                                        @click="
                                            showItems(openPoints.reconciliation.pendingValidation)
                                        "
                                    >
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center justify-center"
                                            style="border-right: 1px #ededed solid"
                                        >
                                            <v-icon
                                                :color="
                                                    openPoints.reconciliation.pendingValidation
                                                        .count
                                                        ? 'red'
                                                        : 'green'
                                                "
                                                >{{
                                                    openPoints.reconciliation.pendingValidation
                                                        .count
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"
                                                }}</v-icon
                                            >
                                        </v-col>
                                        <v-col cols="10" class="d-flex align-center pl-2">
                                            {{
                                                $t("openPoints.toValidateReconciliations", {
                                                    count: openPoints.reconciliation
                                                        .pendingValidation.count,
                                                })
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="
                                        openPoints.reconciliation &&
                                        openPoints.reconciliation.pendingValidation
                                    "
                                >
                                    <v-row
                                        no-gutters
                                        class="pa-3 fill-height bg-primary-foreground rounded-xl"
                                        @click="showWaitingBT()"
                                    >
                                        <v-col
                                            cols="2"
                                            class="d-flex align-center justify-center"
                                            style="border-right: 1px #ededed solid"
                                        >
                                            <v-icon
                                                :color="
                                                    openPoints.waitingAccount.accountingTransactions
                                                        .length
                                                        ? 'red'
                                                        : 'green'
                                                "
                                                >{{
                                                    openPoints.waitingAccount.accountingTransactions
                                                        .length
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"
                                                }}</v-icon
                                            >
                                        </v-col>
                                        <v-col cols="10" class="d-flex align-center pl-2">
                                            {{
                                                $t("openPoints.waitingAccount", {
                                                    count: openPoints.waitingAccount
                                                        .accountingTransactions.length,
                                                })
                                            }}
                                        </v-col>
                                    </v-row>
                                    <!-- <SingleDataCard
                                :title="$t('openPoints.waitingAccount', openPoints.waitingAccount.accountingTransactions.length)"
                                icon="$fa-university"
                                :value="openPoints.waitingAccount.accountingTransactions.length"
                                :color="openPoints.waitingAccount.accountingTransactions.length ? 'yellow':'green'"
                                size="30"
                                v-if="openPoints.waitingAccount && openPoints.waitingAccount.accountingTransactions"
                            ></SingleDataCard> -->
                                </v-col>
                            </v-row>
                            <v-row
                                :key="refreshKey"
                                v-if="!outStangingType || outStangingType === 'user'"
                            >
                                <v-col cols="12">
                                    <v-tabs
                                        v-model="tabStep"
                                        fixed-tabs
                                        style="
                                            background-color: transparent !important;
                                            border-radius: 16px 16px 0 0;
                                            overflow: hidden;
                                        "
                                        id="EnCours"
                                    >
                                        <v-tab
                                            key="471"
                                            href="#471"
                                            v-if="
                                                openPoints.waitingAccount &&
                                                openPoints.waitingAccount.accountingTransactions &&
                                                openPoints.waitingAccount.accountingTransactions
                                                    .length
                                            "
                                        >
                                            <strong>{{
                                                $t("openPoints.category.471")
                                            }}</strong></v-tab
                                        >
                                        <v-tab
                                            :key="category.name"
                                            :href="'#' + category.name"
                                            v-for="category in openPoints.categories"
                                        >
                                            <strong>{{
                                                $t("openPoints.category." + category.name3)
                                            }}</strong></v-tab
                                        >
                                    </v-tabs>
                                    <v-window v-model="tabStep">
                                        <!-- </v-tabs> -->
                                        <!-- <v-tabs-window v-model="tabStep"> -->
                                        <v-window-item
                                            value="471"
                                            v-if="
                                                openPoints.waitingAccount &&
                                                openPoints.waitingAccount.accountingTransactions &&
                                                openPoints.waitingAccount.accountingTransactions
                                                    .length
                                            "
                                        >
                                            <v-row class="pt-1">
                                                <v-col>
                                                    <template
                                                        v-if="
                                                            openPoints &&
                                                            openPoints.waitingAccount &&
                                                            openPoints.waitingAccount
                                                                .accountingTransactions
                                                        "
                                                    >
                                                        <AccountableAccountBalanceDetailOpenPoints
                                                            :companyId="companyId"
                                                            :accountingPeriodId="accountingPeriodId"
                                                            :mode="mode"
                                                            :btOnly="true"
                                                            :accountableAccountInfo="
                                                                openPoints.waitingAccount
                                                            "
                                                            :inAccountingTransactions="
                                                                openPoints.waitingAccount
                                                                    .accountingTransactions
                                                            "
                                                            @bankTransactionSelected="
                                                                onBankTransactionSelected($event)
                                                            "
                                                            @refresh="refresh()"
                                                        >
                                                        </AccountableAccountBalanceDetailOpenPoints>
                                                        <!-- <template
                                                    v-for="(accountingTransaction, i) in openPoints.waitingAccount.accountingTransactions"
                                                    >
                                                    <v-divider
                                                        :key=" 'waitingAccount-' + i + '-divider'"
                                                        :inset="true"
                                                        ></v-divider>
                                                        <v-list-item
                                                            link
                                                            :key=" 'waitingAccount-' + i"
                                                        >
                                                        <v-list-item-icon>
                                                            <v-icon>new_releases</v-icon>
                                                        </v-list-item-icon>
                                                            <v-list-item-title>{{accountingTransaction.wording + (accountingTransaction.invoiceNumber ? (' - ' + accountingTransaction.invoiceNumber): '')}}</v-list-item-title>
                                                            <v-list-item-subtitle>{{newCommonFormatCurrency(-accountingTransaction.debit + accountingTransaction.credit, undefined)}}</v-list-item-subtitle>
                                                        <template v-slot:append>
                                                            <v-list-item-action-text>{{getDate(accountingTransaction.date)}}</v-list-item-action-text>
                                                            <v-btn icon @click.stop="bankTransactionId = accountingTransaction.object.id; wizardStep = 2" v-if="accountingTransaction.object && accountingTransaction.object.type==='bankTransaction'">
                                                                <v-icon color="secondary"  size="small">$edit</v-icon>
                                                            </v-btn>
                                                        </template>
                                        </v-list-item>
                                        </template> -->
                                                    </template>
                                                </v-col>
                                            </v-row>
                                        </v-window-item>
                                        <v-window-item
                                            v-for="category in openPoints.categories"
                                            :value="category.name"
                                        >
                                            <v-row class="pt-1">
                                                <v-col>
                                                    <v-data-table
                                                        :hide-default-header="true"
                                                        :items="category.auxiliaryBalances"
                                                        :items-per-page="-1"
                                                        hide-default-footer
                                                        density="compact"
                                                        class="table"
                                                    >
                                                        <template v-slot:item="props">
                                                            <template
                                                                v-if="
                                                                    showItem(
                                                                        category.name,
                                                                        props.item,
                                                                    )
                                                                "
                                                            >
                                                                <tr
                                                                    style="background-color: #fff"
                                                                    :key="props.item.key"
                                                                    @click.stop="
                                                                        auxiliaryBalancesExpand(
                                                                            props.item,
                                                                        )
                                                                    "
                                                                >
                                                                    <td class="text-center">
                                                                        <v-icon>{{
                                                                            props.item.showDetail
                                                                                ? "$fa-chevron-up"
                                                                                : "$fa-chevron-down"
                                                                        }}</v-icon>
                                                                    </td>
                                                                    <td class="text-left">
                                                                        <div>
                                                                            <strong>{{
                                                                                getAuxiliaryBalanceTitle(
                                                                                    props.item,
                                                                                )
                                                                            }}</strong>
                                                                        </div>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <strong>{{
                                                                            props.item.diagnostic
                                                                        }}</strong>
                                                                    </td>
                                                                    <td class="text-right">
                                                                        <div>
                                                                            <strong>{{
                                                                                newCommonFormatCurrency(
                                                                                    props.item
                                                                                        .amountSigned,
                                                                                    undefined,
                                                                                )
                                                                            }}</strong>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr v-show="props.item.showDetail">
                                                                    <td
                                                                        colspan="4"
                                                                        style="
                                                                            padding: 0;
                                                                            background: #f4f4f4;
                                                                        "
                                                                        class="py-2 px-0"
                                                                    >
                                                                        <AccountableAccountBalanceDetailOpenPoints
                                                                            :companyId="companyId"
                                                                            :accountingPeriodId="
                                                                                accountingPeriodId
                                                                            "
                                                                            :mode="mode"
                                                                            :accountableAccountInfo="
                                                                                props.item
                                                                            "
                                                                            :inAccountingTransactions="
                                                                                props.item
                                                                                    .accountingTransactions
                                                                            "
                                                                            :notReconciliated="true"
                                                                            v-if="
                                                                                props.item
                                                                                    .activateDetail
                                                                            "
                                                                            v-show="
                                                                                props.item
                                                                                    .showDetail
                                                                            "
                                                                            @bankTransactionSelected="
                                                                                onBankTransactionSelected(
                                                                                    $event,
                                                                                )
                                                                            "
                                                                            @refresh="refresh()"
                                                                        >
                                                                        </AccountableAccountBalanceDetailOpenPoints>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                        <template v-slot:body.append>
                                                            <td class="text-center" />
                                                            <td class="text-left" />
                                                            <td class="text-right">
                                                                <strong>Total</strong>
                                                            </td>
                                                            <td class="text-right">
                                                                <div>
                                                                    <strong
                                                                        :style="
                                                                            totalAmmountSigned(
                                                                                category.auxiliaryBalances,
                                                                            ) < 0
                                                                                ? 'color:red'
                                                                                : ''
                                                                        "
                                                                        >{{
                                                                            newCommonFormatCurrency(
                                                                                totalAmmountSigned(
                                                                                    category.auxiliaryBalances,
                                                                                ),
                                                                                undefined,
                                                                            )
                                                                        }}</strong
                                                                    >
                                                                </div>
                                                            </td>
                                                        </template>
                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                        </v-window-item>
                                    </v-window>
                                </v-col>
                            </v-row>
                            <v-row class="pt-1" v-else>
                                <v-col>
                                    <v-data-table
                                        :hide-default-header="true"
                                        :items="categoryTPC.auxiliaryBalances"
                                        :items-per-page="-1"
                                        hide-default-footer
                                        v-if="categoryTPC"
                                        density="compact"
                                        class="table"
                                    >
                                        <template v-slot:item="props">
                                            <template v-if="showItem('411', props.item)">
                                                <tr
                                                    :key="props.item.key"
                                                    @click.stop="
                                                        auxiliaryBalancesExpand(props.item)
                                                    "
                                                >
                                                    <td class="text-center">
                                                        <v-icon>{{
                                                            props.item.showDetail
                                                                ? "$fa-chevron-up"
                                                                : "$fa-chevron-down"
                                                        }}</v-icon>
                                                    </td>
                                                    <td class="text-left">
                                                        <div>
                                                            <strong
                                                                >{{
                                                                    getAuxiliaryBalanceTitle(
                                                                        props.item,
                                                                    )
                                                                }}
                                                            </strong>
                                                        </div>
                                                        <!-- <div>{{auxiliaryBalanceDiagnostic(props.item)}}</div> -->
                                                    </td>
                                                    <!-- <template v-if="props.item.showDetail">
                                                <td class="text-right" colspan="3"></td>
                                            </template> -->
                                                    <!-- <template v-else> -->
                                                    <!-- <td class="text-right"><strong>{{newCommonFormatCurrency(props.item.totalDebit, undefined)}}</strong></td>
                                                <td class="text-right"><strong>{{newCommonFormatCurrency(props.item.totalCredit, undefined)}}</strong></td> -->
                                                    <td class="text-right">
                                                        <strong>{{ props.item.diagnostic }}</strong>
                                                    </td>
                                                    <td class="text-right">
                                                        <div>
                                                            <strong
                                                                :style="
                                                                    props.item.amountSigned < 0
                                                                        ? 'color:red'
                                                                        : ''
                                                                "
                                                                >{{
                                                                    props.item.amountSigned
                                                                        ? newCommonFormatCurrency(
                                                                              props.item
                                                                                  .amountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"
                                                                }}</strong
                                                            >
                                                        </div>
                                                    </td>
                                                    <!-- </template> -->
                                                </tr>
                                                <tr v-show="props.item.showDetail">
                                                    <td
                                                        colspan="4"
                                                        style="padding: 0; background: #f4f4f4"
                                                        class="py-2 px-0"
                                                    >
                                                        <AccountableAccountBalanceDetailOpenPoints
                                                            :companyId="companyId"
                                                            :accountingPeriodId="accountingPeriodId"
                                                            :mode="mode"
                                                            :accountableAccountInfo="props.item"
                                                            :inAccountingTransactions="
                                                                props.item.accountingTransactions
                                                            "
                                                            :notReconciliated="true"
                                                            v-if="props.item.activateDetail"
                                                            v-show="props.item.showDetail"
                                                            @bankTransactionSelected="
                                                                onBankTransactionSelected($event)
                                                            "
                                                        >
                                                        </AccountableAccountBalanceDetailOpenPoints>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        <template v-slot:body.append>
                                            <td class="text-center" />
                                            <td class="text-left" />
                                            <td class="text-right"><strong>Total</strong></td>
                                            <td class="text-right">
                                                <div>
                                                    <strong>{{
                                                        newCommonFormatCurrency(
                                                            totalAmmountSigned(
                                                                categoryTPC.auxiliaryBalances,
                                                            ),
                                                            undefined,
                                                        )
                                                    }}</strong>
                                                </div>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                            <!-- </v-tabs-window> -->
                            <!-- <template v-if="openPoints && openPoints.waitingAccount && openPoints.waitingAccount.accountingTransactions">
                        <div v-for="(item, index) in openPoints.waitingAccount.accountingTransactions" :key="index">
                            {{item.wording}} - {{item.date}} - {{item.debit}} - {{item.credit}} - {{item.balance}}
                        </div>
                    </template>
                    <div v-if="openPoints">
                        {{openPoints.auxiliaryBalances}}
                    </div> -->
                        </v-window-item>
                        <v-window-item :value="2">
                            <ReconciliationFullClient
                                :openPoints="true"
                                :companyId="companyId"
                                :bankTransactionId="bankTransactionId"
                                :key="bankTransactionId"
                                v-if="bankTransactionId"
                                @back="wizardStep = 1"
                            >
                            </ReconciliationFullClient>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
            <!-- <v-card>
                <v-card-title>
                    Compte d'attente
                </v-card-title>
                <v-card-title-subtitle>
                    {{newCommonFormatCurrency(openPoints.waitingAccount.totalDebit- openPoints.waitingAccount.totalCredit, undefined)}} - {{openPoints.waitingAccount.accountingTransactions.length}} mouvement(s) bancaire(s)
                </v-card-title-subtitle>
            </v-card>
            <v-card>
                <v-card-title>
                    Factures à valider
                </v-card-title>
                <v-card-title-subtitle>
                    {{openPoints.document.pendingValidation.count + "/" + openPoints.document.pendingValidation.totalCount}} document(s) à valider
                </v-card-title-subtitle>
            </v-card>
            <v-card>
                <v-card-title>
                    Mouvements bancaires à valider
                </v-card-title>
                <v-card-title-subtitle>
                    {{openPoints.reconciliation.pendingValidation.count + "/" + openPoints.reconciliation.pendingValidation.totalCount}} mouvement(s) bancaire(s) à valider
                </v-card-title-subtitle>
            </v-card> -->
        </template>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import axios from "axios";
import { RouteLocationRaw } from "vue-router";

import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import SingleDataCard from "../../components/cards/SingleDataCard.vue";
import ReconciliationFullClient from "../ReconciliationFullClient.vue";
import AccountableAccountBalanceDetailOpenPoints from "../AccountableAccountBalanceDetailOpenPoints.vue";
import SepaAuto from "../pay/SepaAuto.vue";
import AuditCheckDocumentDialog from "@/views/document/AuditCheckDocumentDialog.vue";
import AuditCheckCard from "@/views/audit/AuditCheckCard.vue";

import OPEN_POINTS from "../../graphql/openPoints/OpenPoints.gql";

import { AuditCheckDocumentResult } from "@/types/auditCheck.types";

import getEnv from "../../env";
import { NotificationBase } from "../NotificationBase";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getAuditCheckDocuments } from "@/services/audit/auditCheckDocument.services";

import { Component, toNative, Prop, Watch } from "vue-facing-decorator";
import emitter from "@/services/emitter";

const env = getEnv();

@Component({
    components: {
        SingleDataCard,
        ReconciliationFullClient,
        AccountableAccountBalanceDetailOpenPoints,
        SepaAuto,
        AuditCheckDocumentDialog,
        AuditCheckCard,
    },
})
export class OpenPoints extends NotificationBase {
    @Prop({ default: "openPoints" }) mode: any;
    @Prop({ default: "" }) userId: any;
    @Prop({ default: null }) filteredThirdPartyCompanies: any;

    wizardStep = 1;
    tabStep = "";

    refreshKey = 0;

    bankTransactionId = "";
    first = true;

    diagnosticSorting = "Tous";

    payDialog: boolean = false;

    shouldAuditCheckDocumentWithAnomalyDialogBeVisible = false;

    auditCheckDocumentsWithAnomaly: AuditCheckDocumentResult[] = [];

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get showSepa() {
        if (this.mode === "openPoints") return false;
        if (this.outStandingMode) {
            return this.outStangingType === "user";
        }
        // if (!this.tabStep) return false;
        return true;
    }

    get disabledSepa() {
        if (this.tabStep === "471" || this.tabStep === "0") return true;
        return false;
    }

    get sepaTitle() {
        return this.tabStep === "411" ? "Prélèvement" : "Virement";
    }

    get companyId() {
        return this.company.id;
    }

    get company() {
        // if (this.accountingPeriodAdminMode) {
        //     return this.$store.state.user.company
        // }
        return this.$store.state.selected_company;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        // if(this.accountingPeriodAdminMode) {
        //     return false
        // }
        return this.currentUser.isAccountingUser;
    }

    get isAuthorized() {
        if (this.outStandingMode) {
            if (this.outStangingType === "client") {
                return this.currentUser.showOutStandingClient;
            }
            if (this.outStangingType === "supplier") {
                return this.currentUser.showOutStandingSupplier;
            }
            if (this.outStangingType === "user") {
                return this.currentUser.showOutStandingUser;
            }
            // NOT IMPLEMENTED
            debugger;
            return false;
            // if (!this.currentUser.companyUser?.configuration?.outstanding) {
            //     return false;
            // }
            // const outstanding = this.currentUser.companyUser.configuration.outstanding;
            // if (
            //     !outstanding.expenseReport &&
            //     !outstanding.salary &&
            //     !outstanding.selectionClient &&
            //     !outstanding.client &&
            //     !outstanding.supplier
            // ) {
            //     return false;
            // }
            // return true;
        }
        return this.currentUser.profile?.configuration?.accounting?.openPoints;
    }

    get outStandingMode() {
        return this.mode?.startsWith("outstanding");
        // if (this.mode === "outstanding")
        // if (this.isAccountingUser && (!this.currentUser.company || !this.company || this.currentUser.company.id !== this.company.id)) {
        //     return false
        // }
        // if (!(this.currentUser.profile?.configuration?.outstanding)) {
        //     return false
        // }
        // const outstanding = this.currentUser.companyUser.configuration.outstanding
        // if (!outstanding.expenseReport && !outstanding.salary&& !outstanding.selectionClient && !outstanding.client && !outstanding.supplier) {
        //     return false
        // }
        // return true
    }

    get outStangingType() {
        if (this.mode?.startsWith("outstanding")) {
            return this.mode.substring(11)?.toLowerCase();
        }
        return "";
    }

    get openPointMode() {
        return this.mode === "openPoints";
    }

    get accountingPeriodId() {
        return this.accountingPeriod ? this.accountingPeriod.id : "";
    }

    get accountingPeriod() {
        // if(this.accountingPeriodAdminMode) {
        //     return this.accountingPeriodAdminMode
        // }
        return this.$store.state.accountingPeriod.selectedAccountingPeriod;
    }

    get loading() {
        if (this.$apollo.queries.openPoints) {
            return this.$apollo.queries.openPoints.loading;
        }
        return false;
    }

    get currentCategoryName() {
        if (this.tabStep) {
            return this.tabStep;
        } else if (this.outStangingType) {
            return this.rootAA;
        }
        return null;
    }

    get selectedCategory() {
        if (this.openPoints?.categories && this.currentCategoryName) {
            return this.openPoints.categories.find((e) => e.name3 === this.currentCategoryName);
        }
        return null;
    }

    get availableDiagnostics() {
        if (this.selectedCategory && this.currentCategoryName) {
            if (this.currentCategoryName === "401" || this.currentCategoryName === "411") {
                const availableDiagnostics = [];
                for (const auxBalance of this.selectedCategory.auxiliaryBalances) {
                    if (
                        auxBalance.diagnostic &&
                        !availableDiagnostics.includes(auxBalance.diagnostic)
                    ) {
                        availableDiagnostics.push(auxBalance.diagnostic);
                    }
                }
                if (availableDiagnostics.length > 1) {
                    availableDiagnostics.splice(0, 0, "Tous");
                }
                return availableDiagnostics;
            }
        }
        return null;
    }

    get auditCheckDocumentsWithAnomalyCount() {
        return this.auditCheckDocumentsWithAnomaly.reduce(
            (acc, checkDocument) => acc + checkDocument.count,
            0,
        );
    }

    @Watch("availableDiagnostics")
    onAvailableDiagnosticsChanged() {
        if (this.availableDiagnostics) {
            if (!this.availableDiagnostics.length) {
                this.diagnosticSorting = "Tous";
            } else {
                if (this.availableDiagnostics.indexOf(this.diagnosticSorting) === -1) {
                    this.diagnosticSorting = this.availableDiagnostics[0];
                }
            }
        } else {
            this.diagnosticSorting = "Tous";
        }
    }

    getDate(date: string) {
        // return moment(date).format("DD-MM");
        return moment(date).fromNow(true);
    }

    getCreatedDate(date: string) {
        return moment(date).format("DD/MM/YY");
    }

    statusDico = {
        DONE: "Réglé",
        ACCEPTED: "Réglé",
        ACCEPTED_NO_BANK_STATUS: "Réglé", // deprecated, not used since september 2023
        CREATED: "Envoyé",
    };

    formatStatus(status: string) {
        if (this.statusDico[status]) {
            return this.statusDico[status];
        }
        return status;
    }

    /**
     * When the selected accounting period or company changes, we need to reinitialize open opoints and the audit check document data.
     */
    @Watch("companyId")
    @Watch("accountingPeriodId")
    async onChange(): Promise<void> {
        this.openPoints = null;
        await this.initializeAuditCheckDocumentAnomalyCardAndDialog();
    }

    @Watch("tabStep")
    adaptDiagnosticSorting() {
        this.diagnosticSorting = "Tous";
    }

    async beforeMount(): Promise<void> {
        if (this.$route.params.activeTab) {
            if (this.$route.params.activeTab === "411" || this.$route.params.activeTab === "401") {
                this.tabStep = this.$route.params.activeTab;
            }
        }
        this.addListener("openPoints");
        await this.initializeAuditCheckDocumentAnomalyCardAndDialog();
    }

    async initializeAuditCheckDocumentAnomalyCardAndDialog(): Promise<void> {
        this.auditCheckDocumentsWithAnomaly = [];
        this.auditCheckDocumentsWithAnomaly = await getAuditCheckDocuments(
            this.$apollo,
            this.companyId,
            this.accountingPeriodId,
        );
    }

    computeAccountingPeriodText(accountingPeriod) {
        let text = moment(accountingPeriod.start).format("DD-MM-YYYY");
        text += " / ";
        text += moment(accountingPeriod.end).format("DD-MM-YYYY");
        return text;
    }

    openParamCompany() {
        if (this.first) {
            const category = this.openPoints.categories.find(
                (cat) => cat.name == this.$route.params.activeTab,
            );
            if (category != undefined) {
                const ab = category.auxiliaryBalances.find(
                    (ab) => ab.thirdPartyCompanyName == this.$route.params.companyName,
                );
                if (ab != undefined) {
                    ab.activateDetail = true;
                    ab.showDetail = true;
                }
                // this.getElementByKey(ab.name).scrollIntoView()
            }
            this.first = false;
        }
    }

    get rootAA() {
        return this.outStangingType === "client"
            ? "411"
            : this.outStangingType === "supplier"
              ? "401"
              : "";
    }

    get categoryTPC() {
        if (this.rootAA) {
            for (const category of this.openPoints.categories) {
                if (category.name3 === this.rootAA) {
                    return category;
                }
            }
        } else {
            debugger;
        }
        return null;
    }

    @Apollo({
        query: OPEN_POINTS,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                withAccountingChat: this.openPointMode,
                outstanding: this.outStangingType,
                userId: this.userId,
                onlyGlobalStatus: false,
            };
        },
        skip() {
            return !this.isAuthorized || !this.companyId || !this.accountingPeriodId;
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.openPoints) {
                    if (!data.openPoints.output.categories) {
                        // hack : result is called twice or three time with the same data
                        const categories = [];
                        for (const auxiliaryBalance of data.openPoints.output.auxiliaryBalances) {
                            auxiliaryBalance.loading = false;
                            auxiliaryBalance.active = false;
                            auxiliaryBalance.activateDetail = false;
                            auxiliaryBalance.showDetail = false;
                            this.insertIntoCatergory(categories, auxiliaryBalance);
                        }
                        this.openPoints = data.openPoints.output;
                        this.openPoints.categories = categories;
                        if (this.$route.params.companyName) {
                            this.openParamCompany();
                        }
                    } else {
                        this.openPoints = {};
                    }
                } else {
                    this.openPoints = {};
                }
            }
        },
    })
    openPoints = null;

    showItems(check) {
        if (check.show && check.show.pathName) {
            const location: any = {
                name: check.show.pathName,
            };
            debugger;
            if (check.show.params) {
                location.query = check.show.params;
            }
            this.$router.push(location);
        }
    }

    /**
     * Navigate to the documents page with query parameters to reset the filters and to set a filter on the audit check.
     * @param auditCheckName Name of the wanted AuditCheck as filter
     */
    navigateToDocumentsWithCheckFilter(auditCheckName: string) {
        const location: RouteLocationRaw = {
            path: "/documents",
            query: { auditCheck: auditCheckName, resetFilter: "true" },
        };
        this.$router.push(location);
    }

    showWaitingBT() {
        const location: any = {
            name: "bank",
            query: {
                resetFilter: true,
                reconciliationStatus: "NOT_JUSTIFIED",
            },
        };
        if (this.accountingPeriod) {
            location.query.startDate = this.accountingPeriod.start;
            location.query.endDate = this.accountingPeriod.end;
        }

        this.$router.push(location);
    }

    insertIntoCatergory(categories, auxiliaryBalance) {
        const aaName3 = auxiliaryBalance.name.substring(0, 3);
        let category = categories.find((c) => c.name === auxiliaryBalance.name);
        if (!category) {
            category = {
                name: auxiliaryBalance.name,
                name3: aaName3,
                auxiliaryBalances: [],
            };
            categories.push(category);
        }
        category.auxiliaryBalances.push(auxiliaryBalance);
    }

    getAuxiliaryBalanceTitle(auxiliaryBalance) {
        let title = "";
        // if (item.name.startsWith("401")) {
        //     title += "Fournisseur : "
        // } else if (item.name.startsWith("411")) {
        //     title += "Client : "
        // } else if (item.name.startsWith("421")) {
        //     title += "Salarié : "
        // } else {
        //     title = item.name
        // }
        title += auxiliaryBalance.description || "XXX";
        return title;
    }

    onBankTransactionSelected(data) {
        this.bankTransactionId = data;
        this.wizardStep = 2;
    }

    onAuditCheckCardClicked(): void {
        this.shouldAuditCheckDocumentWithAnomalyDialogBeVisible = true;
    }

    async auxiliaryBalancesExpand(auxiliaryBalance) {
        if (!auxiliaryBalance.activateDetail) {
            auxiliaryBalance.activateDetail = true;
        }
        auxiliaryBalance.showDetail = !auxiliaryBalance.showDetail;
    }

    async refresh() {
        if (this.$apollo?.queries?.openPoints?.refresh) {
            this.$apollo.queries.openPoints.refetch();
        }
        this.refreshKey++;
    }

    exportLoading: boolean = false;
    stepData = null;

    async exportToFormat(format) {
        this.exportLoading = true;
        switch (format) {
            case "docx":
                console.log("openPoints to DOCX");
                await axios.get(
                    `${env.VUE_APP_BACKEND}/openPoints/download/${
                        this.companyId
                    }/accountingPeriod/${this.accountingPeriodId}/docx?dt="${new Date().getTime()}`,
                    {},
                );
                break;
            case "xlsx":
                await axios.get(
                    `${env.VUE_APP_BACKEND}/openPoints/download/${
                        this.companyId
                    }/accountingPeriod/${this.accountingPeriodId}/xlsx?dt="${new Date().getTime()}`,
                    {},
                );
                console.log("openPoints to XLSX");
                break;
            case "pdf":
                await axios.get(
                    `${env.VUE_APP_BACKEND}/openPoints/download/${
                        this.companyId
                    }/accountingPeriod/${this.accountingPeriodId}/pdf?dt="${new Date().getTime()}`,
                    {},
                );
                console.log("openPoints to PDF");
                break;
            default:
                break;
        }
        // this.exportLoading = false
    }

    onMessage(data) {
        if (data.extraPayload?.signedUrl) {
            this.stepData = null;
            this.exportLoading = false;
            window.open(data.extraPayload.signedUrl, "_blank");
        } else {
            this.stepData = data.extraPayload;
            this.exportLoading = false;
        }
    }

    totalAmmountSigned(balances) {
        let balance = 0;
        for (const row of balances) {
            if (this.diagnosticSorting === "Tous" || row.diagnostic === this.diagnosticSorting) {
                balance += row.amountSigned;
            }
        }
        return balance;
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("EnCours"),
                title: "Les encours",
                pages: [
                    {
                        text: "Les encours sont répartis par nature sous différents onglets.",
                        position: "top",
                        align: "center",
                    },
                ],
            },
        ]);
    }

    showItem(categoryName, item) {
        if (this.diagnosticSorting === "Tous" || item.diagnostic === this.diagnosticSorting) {
            if (
                (categoryName !== "411" && categoryName !== "401") ||
                !this.filteredThirdPartyCompanies ||
                this.filteredThirdPartyCompanies.find(
                    (fc) => fc.name === item.thirdPartyCompanyName,
                )
            ) {
                return true;
            }
        }
        return false;
    }
}

export default toNative(OpenPoints);
</script>
